import ApiService from '@/service/api.service.js'
import types from './mutation-types'

export const getAllPolicies = ({ commit }) => {
  commit(types.FETCH_POLICIES_PENDING)
  ApiService.getAllPolicies()
    .then((res) => {
      if (res.error) {
        commit(types.FETCH_POLICIES_FAILURE)
      } else {
        commit(types.LOAD_POLICIES, res.data)
        commit(types.FETCH_POLICIES_SUCCESS)
      }
    })
    .catch((err) => {
      commit(types.FETCH_POLICIES_FAILURE)
      console.error(err)
    })
}
export const setPolicyType = ({ commit }, policyType) => {
  switch (policyType) {
    case 'any_policy':
    case 'and_policy':
    case 'not_policy':
      commit(types.SET_POLICY_TYPE, policyType)
      break
    default:
      commit(types.SET_POLICY_TYPE, 'any_policy')
  }
}
